import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAtomValue } from "jotai";
import { ArrowUpCircle, CheckCircle2, Clock } from "lucide-react";
import { formatRelativeTime } from "../lib/hostingLabels";
import { komodoConnectionAtom } from "../atoms/komodoConnectionAtom";
import styles from "./KomodoBadge.module.scss";
/** Shown next to StatusBadge whenever a system has a Komodo stack configured. */
export function KomodoBadge({ system }) {
    const connection = useAtomValue(komodoConnectionAtom);
    if (!system.komodoStackName) {
        return null;
    }
    const checkedTitle = `Stack: ${system.komodoStackName} — senast kontrollerad ${formatRelativeTime(system.komodoLastCheckedAt).toLowerCase()}`;
    if (system.komodoLastCheckedAt === null) {
        return (_jsxs("span", { className: `${styles.badge} ${styles.pending}`, title: `Stack: ${system.komodoStackName} — väntar på första kontrollen`, children: [_jsx(Clock, { size: 14, "aria-hidden": "true" }), "V\u00E4ntar"] }));
    }
    if (system.komodoUpdateAvailable) {
        const komodoBaseUrl = connection.state === "hasData" ? connection.data.url : null;
        const stackUrl = komodoBaseUrl && system.komodoStackId
            ? `${komodoBaseUrl.replace(/\/+$/, "")}/stacks/${system.komodoStackId}`
            : null;
        if (stackUrl) {
            return (_jsxs("a", { href: stackUrl, target: "_blank", rel: "noreferrer", className: `${styles.badge} ${styles.available}`, title: `${checkedTitle} — öppna i Komodo`, children: [_jsx(ArrowUpCircle, { size: 14, "aria-hidden": "true" }), "Uppdatering"] }));
        }
        return (_jsxs("span", { className: `${styles.badge} ${styles.available}`, title: checkedTitle, children: [_jsx(ArrowUpCircle, { size: 14, "aria-hidden": "true" }), "Uppdatering"] }));
    }
    return (_jsxs("span", { className: `${styles.badge} ${styles.current}`, title: checkedTitle, children: [_jsx(CheckCircle2, { size: 14, "aria-hidden": "true" }), "Aktuell"] }));
}
